/** @format */

import {Box, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';

export const LevelItem = styled(Box)(({theme}) => ({
  display: 'grid',
  gridTemplateColumns: '72px 1fr 56px 72px',
  alignItems: 'stretch',
  minHeight: theme.spacing(18),
  padding: 0,
  background: theme.palette.figma_gray_dark_1?.main,
  border: `1px solid ${theme.palette.figma_gray_dark_1?.main}`,
  borderRadius: '8px',
}));

export const LevelContent = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  padding: theme.spacing(4),
}));

export const LevelTitle = styled(Typography)(({theme}) => ({
  color: theme.palette.text.primary,
  fontSize: '16px',
  fontWeight: 700,
  lineHeight: '20px',
}));

export const LevelSubtitle = styled(Typography)(({theme}) => ({
  color: theme.palette.text.primary,
  opacity: 0.7,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
}));

export const LevelActions = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  borderRight: `1px solid ${theme.palette.figma_gray_dark_1?.main}`,
}));

export const LevelDropdownArea = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderLeft: `1px solid ${theme.palette.figma_gray_dark_1?.main}`,
  borderRight: `1px solid ${theme.palette.figma_gray_dark_1?.main}`,
}));

export const LevelRight = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const ErrorText = styled(Typography)(({theme}) => ({
  color: theme.palette.error.main,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
}));
